module.exports = __webpack_public_path__ + "images/sticky-banner-bg-mobile.png";